<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>고객 정보</h3></li>
            <li><element-select v-model="processorData.steps[0].formData.gestationalAge.value" :error="processorData.steps[0].formData.gestationalAge.error" :label="processorData.steps[0].formData.gestationalAge.label" :placeholder="processorData.steps[0].formData.gestationalAge.placeholder" :items="processorData.steps[0].formData.gestationalAge.option" :dropbox="processorData.steps[0].formData.gestationalAge.dropbox"/></li>
            <li><element-textbox v-model="processorData.steps[0].formData.birth.value" :error="processorData.steps[0].formData.birth.error" :label="processorData.steps[0].formData.birth.label" :placeholder="processorData.steps[0].formData.birth.placeholder" /></li>
            <div class="form-item-caution">정확한 보험료 산출을 위해 활용됩니다.</div>
          </ul>
          <ul class="form-item-list">
            <li><element-spread-select v-model="processorData.steps[0].formData.job.value" :error="processorData.steps[0].formData.job.error" :label="processorData.steps[0].formData.job.label" :items="processorData.steps[0].formData.job.items" /></li>
          </ul>
          <div class="form-item-caution">찾는 직업이 없는경우, 가장 비슷한 직업으로 선택하신 후 상담예약에 내용을 남겨주시면 해당하는 직업으로 변경해 드립니다.</div>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li>
              <element-select v-model="processorData.steps[1].formData.insureDuration.value" :error="processorData.steps[1].formData.insureDuration.error" :label="processorData.steps[1].formData.insureDuration.label" :placeholder="processorData.steps[1].formData.insureDuration.placeholder" :items="processorData.steps[1].formData.insureDuration.items" :dropbox="processorData.steps[1].formData.insureDuration.dropbox"/>
            </li>
            <li v-for="(options, index) in processorData.steps[1].formData.insureOptions" :key="index">
              <element-content-checkbox @status="popup" v-model="processorData.steps[1].formData.insureOptions[index].value" :error="processorData.steps[1].formData.insureOptions[index].error" :label="processorData.steps[1].formData.insureOptions[index].label" :items="processorData.steps[1].formData.insureOptions[index].items" :index="index" :requirement="processorData.steps[1].formData.insureOptions[index].requirement"/>
            </li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[2]">
          <ul class="form-item-list" id="history-of-treatment">
            <li><h3>치료이력</h3></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.history.value" :error="processorData.steps[2].formData.history.error" :label="processorData.steps[2].formData.history.label" :items="processorData.steps[2].formData.history.items" /></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.inject.value" :error="processorData.steps[2].formData.inject.error" :label="processorData.steps[2].formData.inject.label" :items="processorData.steps[2].formData.inject.items" /></li>
            <li id="history-of-treatment-item"><element-checkbox v-model="processorData.steps[2].formData.have.value" :error="processorData.steps[2].formData.have.error" :label="processorData.steps[2].formData.have.label" :items="processorData.steps[2].formData.have.items" /></li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <include-estimate-auth-self :data="processorData.steps[0]" @updateprocessorData="updateprocessorData" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[4]">
          <ul class="form-item-list">
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultDate.error" :label="processorData.steps[4].formData.consultDate.label" :placeholder="processorData.steps[4].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[4].formData.consultTime.value" :date="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultTime.error" :label="processorData.steps[4].formData.consultTime.label" :placeholder="processorData.steps[4].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[4].formData.consultRemark.value" :error="processorData.steps[4].formData.consultRemark.error" :label="processorData.steps[4].formData.consultRemark.label" :placeholder="processorData.steps[4].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-estimate-complete :data="processorData.steps[5]" />
        </element-processor-step>
        <element-processor-step :data="processorData.steps[6]">
          <include-other-estimate :data="processorData.steps[6]"  :type="processorData.title"/>
        </element-processor-step>
        <transition name="popup">
          <element-popup @status="popup" :process_title="processorData.title" v-model="processorData.steps[1].formData.insureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
          :subLabel="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel" v-if="statusPopup.popup" :statusPopup="statusPopup" :data="processorData.steps[1].formData.insureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment';

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "태아보험 견적서",
        cureData: true,
        steps: [
          {
            title: "고객 정보",
            formData: {
              gestationalAge: {
                label: "임신주수",
                value: "24주차 이상",
                error: "",
                dropbox: "마지막 생리 시작일을 임신 첫날로 두며, 해당 기준일에서 250일 후를 분만 예정일로 확인할 수 있으나 가장 정확한 임신 주수 계산은 산부인과에서 초음파로 화깅ㄴ하는 방법입니다. 또한, 태아보험으로 아기의 출생 시 위험까지 보장받을 수 있는 태아특약을 추가하려면 임신 22주 이전까지 태아보험에 가입해 두셔야 합니다.",
                option: [
                  { value: "21주차 이하", label: "21주차 이하" },
                  { value: "22~23주차", label: "22~23주차" },
                  { value: "24주차 이상", label: "24주차 이상" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "산모 생년월일",
                value: "",
                error: "",
                placeholder: "산모 생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" },
                ]
              },
              job: {
                label: "직업",
                value: "",
                error: "",
                items: [
                  { value: "사무,전문직", label: "사무,전문직" },
                  { value: "운수,건설직", label: "운수,건설직" },
                  { value: "판매,서비스직", label: "판매,서비스직" },
                  { value: "영업용 운전직", label: "영업용 운전직" },
                  { value: "학생,주부", label: "학생,주부" },
                  { value: "무직", label: "무직" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              }
            }
          },
          {
            title: "보장항목",
            formData:
            {
              insureDuration: {
                label: "보험 기간",
                value: "20세 20년납",
                dropbox: "보험기간은 짧게 선택하십시오. 태아보험의 경우, 태아 및 어린이에게 특화된 보장내용이 많고 만 15세가 넘으면 성인이 가입하는 건강보험에 가입할 수 있기 때문에 무조건 보장기간을 길게 하여 가입하는 것이 유리한 것은 아닙니다.",
                error: "",
                items: [
                  { value: "100세 30년납", label: "100세 30년납" },
                  { value: "100세 20년납", label: "100세 20년납" },

                  { value: "30세 30년납", label: "30세 30년납" },
                  { value: "20세 20년납", label: "20세 20년납" },

                ]
              },
              insureOptions: [
                {
                  label: "보장 내용",
                  requirement: true,
                  value: [
                    { label: "태아장해출생", value: "500만원" },
                    { label: "저체중아입원비", value: "일당 1만원" },
                    { label: "신생아질병입원", value: "일당 1만원" },
                    { label: "입원 및 수술비", value: "3,000만원" },
                    { label: "통원 및 약제비", value: "통원 25만원, 약제비 5만원" },
                    { label: "진단 및 치료비(다중선택)", value: ["상해"] }
                  ],
                  error: "",
                  items: [
                    { value: "태아장해출생", label: "태아장해출생", description: [
                      { value: "피보험자가 장해로 출생한 경우, 저체중아, 일반장해, 심한장해별 가입금액 각각 최초 1회 차등지급" }
                    ], subLabel: "500만원", link: { name: "Home" },
                      options: [
                        { value: "1,000만원", label: "1,000만원" },
                        { value: "500만원", label: "500만원" },
                      ] },
                    { value: "저체중아입원비", label: "저체중아입원비", description: [
                      { value: "피보험자가 미숙아로 출생하여 인큐베이터를 이용한 경우, 3일 이상부터 1일당 60일 한도로 가입금액 지급 / 출생후 1년내  질병으로 입원한 경우, 4일 이상부터 1일당 120일 한도로 가입금액 지급" }
                    ], subLabel: "일당 1만원", link: { name: "Home" },
                      options: [
                        { value: "일당 5만원", label: "일당 5만원" },
                        { value: "일당 2만원", label: "일당 2만원" },
                        { value: "일당 1만원", label: "일당 1만원" }
                      ] },
                    { value: "신생아질병입원", label: "신생아질병입원", description: [
                      { value: "피보험자가 출생전후기 질병으로 출생후 1년내 입원한 경우, 4일 이상부터 1일당 120일 한도로 가입금액 지급" }
                    ], subLabel: "일당 1만원", link: { name: "Home" },
                      options: [
                        { value: "일당 5만원", label: "일당 5만원" },
                        { value: "일당 1만원", label: "일당 1만원" },
                      ] },
                    { value: "입원 및 수술비", label: "입원 및 수술비", description: [
                      { value: "" }
                    ], subLabel: "3,000만원", link: { name: "Home" },
                      options: [
                        { value: "5,000만원", label: "5,000만원" },
                        { value: "3,000안원", label: "3,000만원" },
                      ] },
                    { value: "통원 및 약제비", label: "통원 및 약제비", description: [
                      { value: "" }
                    ], subLabel: "통원 25만원, 약제비 5만원", link: { name: "Home" },
                      options: [
                        { value: "통원 25만원, 약제비 5만원", label: "통원 25만원, 약제비 5만원" },
                        { value: "통원 20만원, 약체비 10만원", label: "통원 20만원, 약체비 10만원" },
                      ] },
                    { value: "진단 및 치료비(다중선택)", label: "진단 및 치료비(다중선택)", description: [
                      { value: "ADHD진단 - 피보험자가 6세부터 ADHD(활동성 및 주의력 장애)로 진단받은 경우 가입금액 최초 1회 지급" },
                      { value: "아토피진단 - 피보험자가 중증아토피로 진단받은 경우 최초 1회 가입금액 지급" },
                      { value: "성조숙증 - 피보험자가 5세부터 성조숙증으로 진단받은 경우 가입금액 최초 1회 지급" }
                    ], subLabel: "상해", link: { name: "Home" },
                      options: [
                        { value: "상해", label: "상해" },
                        { value: "질병", label: "질병" },
                        { value: "암", label: "암" },
                        { value: "장애", label: "장애" },
                        { value: "ADHD", label: "ADHD" },
                        { value: "아토피", label: "아토피" },
                        { value: "성조숙", label: "성조숙" },
                        { value: "치아", label: "치아" },
                      ] },
                  ],
                },
                {
                  label: "추가 특약",
                  requirement: false,
                  value: [],
                  error: "",
                  items: [
                    { value: "산모실손의료비", label: "산모실손의료비", description: [
                      { value: "피보험자(부양자)가 임신질환으로 입원치료를 받은 경우 의료비를 보험가입금액 한도 내에서 실손보상(상급병실료 일부보상). 단, 분만입원의 경우 총입원일수가 통상분만입원일수(자연분만은 4일, 제왕절개는 8일)를 초과하는 경우에 한하여 보상" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "1,000만원", label: "1,000만원" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "의료사고법률비용", label: "의료사고법률비용", description: [
                      { value: "피보험자가 의료법 제3조에서 정한 의료기관에서 의사의 진단에 따른 치료 중 또는 그 치료의 직접결과로 의료사고가 발생하여 소를 제기한 경우 변호사 착수금의 80%해당액으로 1사고당 가입금액 한도 지급(단, 1심에 한함)" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "200만원", label: "200만원" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "일상생활배상책임", label: "일상생활배상책임", description: [
                      { value: "피보험자 본인 및 피보험자의 가족(배우자, 자녀)이 일상생활중 우연한 사고로 타인의 신체에 장해 또는 재물에 손해를 입힘으로써 법률상의 배상책임을 부담하는 경우, 자기부담금을 제외하고 가입금액 한도로 실손보상" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "1억원", label: "1억원" },
                        { value: "미가입", label: "미가입" },
                      ] },
                  ]
                }
              ]
            }
          },
          {
            title: "치료이력",
            formData: {
              birth: {
                label: "생년월일",
                placeholder: "생년월일 6자리 입력",
                value: "",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" },
                ]
              },
              history: {
                label: "최근 3개월 이내 질병 또는 상해로 약을 먹거나 치료한 경험이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "치료", label: "치료" },
                  { value: "검사", label: "검사" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              inject: {
                label: "최근 5년 이내 입원, 수술 혹은 30일 이상 투약한 경험이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "2년 이내", label: "2년 이내" },
                  { value: "2~5년", label: "2~5년" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              have: {
                label: "관리하고 있는 질병이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "당뇨병", label: "당뇨병" },
                  { value: "고혈압", label: "고혈압" },
                  { value: "고지혈증", label: "고지혈증" },
                  { value: "뇌혈관질환", label: "뇌혈관질환" },
                  { value: "심혈관질환", label: "심혈관질환" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "array", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: "본인 확인",
            formData: {
              // haslogin: {
              //   value: "",
              //   validations: [
              //     { type: "required", message: "-" }
              //   ]
              // },
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
                // validations: [
                //   { type: "required", message: "-" }
                // ]
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간 선택",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ], // steps
        reservation_inflow_referer_source: '',
      }
    }
  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[4].formData.consultDate.value = date;
    }

    this.processorData.steps[4].formData.consultTime.value = time;

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[3].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[3].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }

          if (this.reservation_inflow_referer_source !== '') {
            reservation_data.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      /*
      if(this.statusPopup.option == 0 && this.statusPopup.index == 5) { // 진단 및 치료비(다중선택)

        if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.length > 1){
          var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.findIndex(o => o == value);
          if(index >= 0){
            var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.splice(index, 1);
          }else{
            this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.push(value);
          }
        }else if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.length == 1){
          var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.findIndex(o => o == value);
          if(index == -1){
            this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.push(value);
          }

        }

        this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value[this.statusPopup.index].value.join();
        if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

          var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
          if(value === '미가입' && !this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].requirement){
            this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.splice(index, 1);
          }
        }else{
          if(value != '미가입'){
            var tmp = { label: this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
            this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.push( tmp )
          }
        }

      }else{
        this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;

        if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

          var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
          if(value === '미가입' && !this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].requirement){
            this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.splice(index, 1);
          }
        }else{
          if(value != '미가입'){
            var tmp = { label: this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
            this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.push( tmp )
          }
        }
      }
      */
      var insureOptionsObj = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option];
      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      insureOptionsObj.items[this.statusPopup.index].subLabel = value;
      if(Vidx >= 0){
        if(value === '미가입' && !insureOptionsObj.requirement){
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 1) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    updateprocessorData: function (data){
      //this.processorData.steps[3].formData.haslogin.value = data.haslogin;
      this.processorData.steps[3].formData.phone.value = data.phone;
      this.processorData.steps[3].formData.name.value = data.name;
      this.processorData.steps[3].formData.email.value = data.email;
      this.processorData.steps[3].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[3].formData.name.value },
            phone: { value: this.processorData.steps[3].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o

          if (this.reservation_inflow_referer_source !== '') {
            tmp.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          
          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
